module.exports = __webpack_public_path__ + "img/Group 242.616a28ee.svg";